/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeVerifications.defs.js'
export * as $defs from './revokeVerifications.defs.js'
